import React, { Component } from 'react';
import axios from 'axios';
import ModalUpdateIdol from './Components/ModalUpdateIdol';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';

export default class IdolManagerPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            idolList: [],
            idol: null,
            loading: false
        }
        this.getActiveIdol = this.getActiveIdol.bind(this);
    }

    getActiveIdol() {
        let url = global.config.apiDomain + "/rest/idol-manager/getActiveIdol"
        axios.post(url, {})
            .then(res => {
                this.setState({ idolList: res.data.idolList || [] });
            })
    }

    componentDidMount() {
        this.getActiveIdol();
    }

    render() {
        const { idolList, idol } = this.state;
        return (
            <>
                <ModalUpdateIdol idol={idol} idolList={idolList} onUpdated={this.getActiveIdol}></ModalUpdateIdol>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lí Idol</h1>
                        <table className="table table-hover">
                            <thead>
                                <tr className="text-center">
                                    <th className="align-middle" scope="col">STT</th>
                                    <th className="align-middle" scope="col">Facebook ID</th>
                                    <th className="align-middle" scope="col">UID</th>
                                    <th className="align-middle" scope="col">Name</th>
                                    <th className="align-middle" scope="col">Avatar</th>
                                    <th className="align-middle" scope="col">Trạng thái</th>
                                    <th className="align-middle" scope="col">Chỉnh sửa</th>
                                    <th className="align-middle" scope="col">Add bài thu</th>
                                </tr>
                            </thead>
                            <tbody>
                                {idolList && idolList.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className="align-middle text-center" scope="col">{index + 1}</td>
                                            <td className="align-middle text-center" scope="col">{item.id}</td>
                                            <td className="align-middle text-center" scope="col">{item.uid}</td>
                                            <td className="align-middle text-center" scope="col">{item.name}</td>
                                            <td className="align-middle text-center" scope="col">
                                                <img src={item.avatar} alt="" style={{ width: "100px" }} />
                                            </td>
                                            <td className="align-middle text-center" scope="col">{item.signature}</td>
                                            <td className="align-middle text-center" scope="col">
                                                <button className='btn btn-info'
                                                    data-toggle="modal"
                                                    data-target="#ModalUpdateIdol"
                                                    onClick={() => {
                                                        this.setState({
                                                            idol: item
                                                        })
                                                    }}
                                                >Chỉnh sửa</button>
                                            </td>
                                            <td className="align-middle text-center" scope="col">
                                                <Link to={`/admin/idol-recording/${item.id}?language=en.yokara`} className="dropdown-item">
                                                    <i className="fa-solid fa-music mr-2"></i>
                                                    Add bài thu Yokara
                                                </Link>
                                                <Link to={`/admin/idol-recording/${item.id}?language=vi`} className="dropdown-item">
                                                    <i className="fa-solid fa-music mr-2"></i>
                                                    Add bài thu iKara
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    }
}

